export var DEPLOY_DATE = new Date('2026-07-09T21:59:13+0000');
